import React, { useRef } from 'react';
import { Icon } from 'ui';

const CriteriaSearch = ({ query, toggleQuery, searchFeedbackCriteria }) => {
  const ref = useRef(null);
  const clearInput = () => {
    toggleQuery('');
    ref.current.focus();
  };

  return (
    <div className="AddCriteriaModal-search">
      <input
        className="AddCriteriaModal-input RemoveIcon"
        placeholder={searchFeedbackCriteria}
        ref={ref}
        onChange={e => toggleQuery(e.target.value)}
        value={query}
      />
      <Icon
        name={query ? 'close-circle' : 'search'}
        onClick={query ? clearInput : null}
      />
    </div>
  );
};

export default CriteriaSearch;
